export default __webpack_public_path__ + "static/media/Nunito-Bold.a2299071.woff";